import common from "@/api/common";
import Gleap from "gleap";
import moment from "moment";
// export const aiFeedback = function (vm) {
//   var survey = vm.$ls.get("ai-feedback");
//   var aiUse = vm.$ls.get("tryNow");
//   if (!survey && aiUse) {
//     // Gleap.trackEvent("AI Used");
//   }
// };
export const formatDate = function (date, formatString) {
  return moment(date).format(formatString);
};
export const percentageVieW = function (sum, Total) {
  Total = parseInt(Total);
  sum = parseInt(sum);
  var Percent;
  if (sum === 0 || Total === 0) {
    Percent = 0;
  } else {
    Percent = parseFloat(sum / Total) * 100;
    if (isNaN(Percent)) {
      Percent = 0;
    }
  }
  // return Percent.toFixed(2).replace(/[.,]0$/, '')
  return floorFigure(Percent, 2);
};

export const percentageToFixed = function (sum, Total) {
  Total = parseInt(Total);
  sum = parseInt(sum);
  if (sum === 0 || Total === 0) {
    var Percent = 0;
  } else {
    Percent = parseFloat(sum / Total) * 100;
    if (isNaN(Percent)) {
      Percent = 0;
    }
  }
  // return Percent.toFixed(2).replace(/[.,]0$/, '')
  return floorFigure(Percent, 2);
};

export const getRandomItem = function (arr) {
  const randomIndex = Math.floor(Math.random() * arr.length);
  const item = arr[randomIndex];
  return item;
};

function floorFigure(figure, decimals) {
  if (!decimals) decimals = 2;
  var d = Math.pow(10, decimals);
  return (parseInt(figure * d) / d).toFixed(decimals);
}

export const convertCount = function (count) {
  count = parseInt(count);
  if (isNaN(count)) return count;

  if (count < 1000) {
    return count;
  } else {
    return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const dummyRows = function (rows = 10) {
  return Array.apply(null, { length: rows }).map(function () {
    return {};
  });
};

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== "string" || !string) {
    return "";
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getErrorMessage = (err) => {
  if (err.errors && err.errors[0] && err.errors[0].message) {
    return err.errors[0].message;
  } else if (err.message) {
    return err.message;
  }
  return "";
};

export const StatusIcon = function (status) {
  var icon = "";
  switch (status) {
    case "Finished":
    case "Queue Finished":
      icon = "finished";
      break;
    case "Publish":
    case "Published":
    case "Active":
      icon = "active";
      break;
    case "Aborted":
      icon = "abort";
      break;
    case "Duplicate":
      icon = "circle-duplicate";
      break;
    case "Draft":
      icon = "draft";
      break;
    case "Processing":
    case "Queue Started":
    case "Queued":
      icon = "yellow-load";
      break;
    case "Scheduled":
    case "Rescheduled":
      icon = "schedule";
      break;
    case "Sending":
      icon = "green-process";
      break;
    case "Paused":
      icon = "pause";
      break;
    case "Inactive":
      icon = "inactive-new";
      break;
    case "Archived":
      icon = "archived";
      break;
    case "Expired":
      icon = "inactive-yellow";
      break;
    case "Limit Reached":
      icon = "inactive-red";
      break;
    case "Failed":
      icon = "inactive-red";
      break;
    case "Completed":
      icon = "circle-check";
      break;
    default:
      icon = "circle";
  }
  return icon;
};

export const getHubspotToken = function (vm) {
  var promise = common.getCustomData("hubspot/visitoridentification");
  promise
    .then((response) => {
      if (response.status === "success") {
        if (response.data && response.data.hub_user) {
          vm.$ls.set("hub_user", response.data.hub_user);
          setHubspot(vm);
          var curTime = new Date().getTime();
          vm.$ls.set("hub_user_tokenexpire", curTime);
        }
      }
    })
    .catch(() => {});
};

export const setHubspot = function (vm, source = "normal") {
  var loginData = vm.$ls.get("login_data")
    ? JSON.parse(vm.$ls.get("login_data"))
    : [];
  var hubUser = vm.$ls.get("hub_user") ? vm.$ls.get("hub_user") : "";
  var mainUser = vm.$ls.get("mainUser") ? vm.$ls.get("mainUser") : "";

  if (
    loginData &&
    hubUser &&
    mainUser &&
    parseInt(vm.$ls.get("isAdmin")) === 0
  ) {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.refresh();
    }
    window.hsConversationsSettings = {
      loadImmediately: false,
      // inlineEmbedSelector: '#my-messages-container'
    };
    if (source === "embed") {
      window.hsConversationsSettings.inlineEmbedSelector =
        "#my-messages-container";
    }
    if (window.HubSpotConversations) {
      onConversationsAPIReady(source);
    } else {
      window.hsConversationsOnReady = [onConversationsAPIReady];
    }
  } else {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.remove();
    }
  }
};

export const onConversationsAPIReady = function (source) {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.clear({ resetWidget: true });
  }
  window.hsConversationsSettings = {
    identificationEmail: localStorage.getItem("mainUser"),
    identificationToken: localStorage.getItem("hub_user"),
    // inlineEmbedSelector: '#my-messages-container'
  };
  if (source === "embed") {
    window.hsConversationsSettings.inlineEmbedSelector =
      "#my-messages-container";
  }
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.load();
    window.HubSpotConversations.widget.refresh({ openToNewThread: true });
  }
};

export const getChatbotUserStatus = function (vm) {
  var hubUser = vm.$ls.get("hub_user") ? vm.$ls.get("hub_user") : "";
  var mainUser = vm.$ls.get("mainUser") ? vm.$ls.get("mainUser") : "";
  if (hubUser && mainUser && parseInt(vm.$ls.get("isAdmin")) === 0) {
    return true;
  } else {
    return false;
  }
};

export const removeHubspot = function (vm) {
  vm.$ls.remove("hub_user");
  vm.$ls.remove("mainUser");
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.remove();
  }
};

export const getWelcomeDashCurrentClass = function (welcomeDashboardItems) {
  var completed = "";
  const items = ["addCampaign", "addSenderId", "addDomain", "addContact"];
  items.forEach(function (element) {
    if (welcomeDashboardItems[element] === 0) {
      completed = element;
      return completed;
    }
  });
  return completed;
};

export const getStepDisable = function (module, welcomeDashboardItems) {
  var disableVal = false;
  switch (module) {
    case "senderId":
      if (
        welcomeDashboardItems.addDomain !== 2 &&
        welcomeDashboardItems.addSenderId === 0
      ) {
        disableVal = true;
      }
      break;
    case "campaign":
      if (
        welcomeDashboardItems.addSenderId !== 2 &&
        welcomeDashboardItems.addCampaign === 0
      ) {
        disableVal = true;
      }
      break;
    default:
  }
  return disableVal;
};

export const getTopFixedMessage = function (vm, showLifetimeSuccess) {
  var isApprove = !!(
    vm.$ls.get("is_approve") && parseInt(vm.$ls.get("is_approve")) === 1
  );
  var returnMessage = { topFixMessage: "", topFixVariant: "" };
  if (showLifetimeSuccess) {
    returnMessage.topFixMessage = `<span class="font-weight-semi-bold parti-congrats">Congratulations! </span> You have successfully activated <span class="font-weight-semi-bold">AppSumo</span> lifetime deal to your Mailercloud account`;
    returnMessage.topFixVariant = "fix-green";
    returnMessage.haveClose = true;
    returnMessage.haveParticle = true;
    returnMessage.icon = false;
  } else if (!isApprove) {
    returnMessage.topFixMessage = `We are verifying your eligibility. Start working with our features once the process is complete. `;
    returnMessage.topFixVariant = "fix-black";
    returnMessage.haveClose = false;
    returnMessage.haveParticle = false;
    returnMessage.icon = true;
  }

  return returnMessage;
};
export const goToPage = function (vm, module, welcomeDashboardItems) {
  var path = "";
  switch (module) {
    case "contact":
      if (welcomeDashboardItems.addContact !== 2) {
        path = "recipients";
      }
      break;
    case "domain":
      if (welcomeDashboardItems.addDomain !== 2) {
        path = "account/domains";
      }
      break;
    case "senderId":
      if (
        welcomeDashboardItems.addSenderId !== 2 &&
        (welcomeDashboardItems.addDomain === 2 ||
          welcomeDashboardItems.addSenderId !== 0)
      ) {
        path = "account/sender-management";
      }
      break;
    case "campaign":
      if (
        welcomeDashboardItems.addSenderId === 2 ||
        welcomeDashboardItems.addCampaign !== 0
      ) {
        path = welcomeDashboardItems.campPage
          ? welcomeDashboardItems.campPage
          : "campaign";

        if (path == "campaign") {
          path = "campaigns";
        }
      }
      break;
    default:
  }
  if (path !== "" && vm.$route.path !== "/" + path) {
    vm.$router.push({ path: "/" + path });
  }
};

export const base64DEcode = function (base64string) {
  let bufferObj = Buffer.from(base64string, "base64");
  let decodedString = bufferObj.toString("utf8");
  return decodedString;
};
export const resetLoginJwt = function (vm, token, isPassword = false) {
  var user = JSON.parse(vm.$ls.get("login_data"));
  if (user) {
    user.token = token;
    if (!isPassword) {
      user.is_approve = 1;
      vm.$ls.set("is_approve", 1);
    }
    vm.$ls.set("login_data", JSON.stringify(user));
  }
};
// export const updateIntercom = function (vm, data) {
//   if (parseInt(vm.$ls.get('isAdmin')) === 0) {
//     vm.$intercom.update(data)
//   }
// }

// export const removeIntercomCookie = function (vm) {
//   var app = process.env.VUE_APP_INTERCOM_KEY
//   var host = window.location.hostname
//   var hostArr = host.split('.')
//   hostArr[0] = ''
//   var hostname = hostArr.join('.')
//   var cookname = 'intercom-session-' + app
//   document.cookie = cookname + '=;domain=' + hostname + ' ; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
// }

// export const setIntercom = function (vm, data) {
//   vm.$intercom.shutdown()
//   if (parseInt(vm.$ls.get('isAdmin')) === 0) {
//     var statusText = ''
//     if (data) {
//       switch (data.status) {
//         case '0':
//         case 0:
//           if (parseInt(data.is_approve) === 2) {
//             statusText = 'Rejected'
//           } else {
//             statusText = 'Inactive'
//           }

//           break
//         case '3':
//         case 3:
//           statusText = 'Unverified'
//           break
//         default:
//           if (parseInt(data.is_approve) === 0) {
//             statusText = 'Pending'
//           } else {
//             statusText = 'Active'
//           }
//       }
//     }

//     var planValue = ''
//     if (data && data.plan) {
//       switch (data.plan) {
//         case '1':
//         case 1:
//           planValue = 'Enterprise plan'
//           break
//         case '2':
//         case 2:
//           planValue = 'Premium plan'
//           break
//         default:
//           planValue = 'Free plan'
//       }
//     }

//     var role = vm.$ls.get('client_role')

//     var updateData = {
//       user_id: data.id,
//       name: data.name,
//       email: data.user,
//       Status: statusText,
//       Plan: planValue,
//       created_at: data.createdDate,
//       company: { company_id: data.cid,
//         name: data.companyName,
//         website: data.website

//       }
//     }

//     if (role) {
//       updateData['User Role'] = role
//     }

//     if (data && data.expireDate) {
//       updateData['Plan expire'] = data.expireDate
//     }
//     if (data && data.phone_code) {
//       updateData['Phone code'] = data.phone_code
//     }
//     if (data && data.contactBalance) {
//       updateData['contactBalance'] = data.contactBalance
//     }

//     var expireStatus = 'Active'
//     if (parseInt(data.planExpire) > 0) {
//       expireStatus = 'Expired'
//     }
//     updateData['Plan Status'] = expireStatus

//     var subscription = 'Unpaid'

//     if (data && data.subscription_status) {
//       if (data.subscription_status === 'active') {
//         subscription = 'Paid'
//       }
//     }
//     updateData['Payment Status'] = subscription
//     vm.$intercom.boot(updateData)
//   } else {
//     removeIntercomCookie(vm)
//   }
// }
export const dateFormat = function (unixDate) {
  var date = new Date(unixDate * 1000);
  var formattedDate = date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return formattedDate;
};
export const initializeGleap = function (vm) {
  gleapsetup(vm);
};

function gleapsetup(vm) {
  if (parseInt(vm.$ls.get("isAdmin")) === 0) {
    Gleap.initialize(process.env.VUE_APP_GLEAP_KEY);
  }
}
export const setGleap = function (vm, cid, data) {
  initializeGleap(vm);
  if (parseInt(vm.$ls.get("isAdmin")) === 0) {
    var updateData = {
      created_at: data.customData.createdDate,
    };
    if (data && data.customData.expireDate) {
      updateData["Plan expire"] = data.customData.expireDate;
    }
    var statusText = "";
    if (data) {
      switch (data.customData.Status) {
        case "0":
        case 0:
          if (parseInt(data.customData.is_approve) === 2) {
            statusText = "Rejected";
          } else {
            statusText = "Inactive";
          }

          break;
        case "3":
        case 3:
          statusText = "Unverified";
          break;
        default:
          if (parseInt(data.customData.is_approve) === 0) {
            statusText = "Pending";
          } else {
            statusText = "Active";
          }
          data.customData.Status = statusText;
      }

      var planValue = "";
      if (data && data.customData.Plan) {
        switch (data.customData.Plan) {
          case "1":
          case 1:
            planValue = "Enterprise plan";
            break;
          case "2":
          case 2:
            planValue = "Premium plan";
            break;
          case "4":
          case 4:
            planValue = "Lifetime plan";
            break;
          case "5":
          case 5:
            planValue = "Lifetime + Premium plan";
            break;
          default:
            planValue = "Free plan";
        }
        data.customData.Plan = planValue;
      }
      Gleap.identify(cid, data);
    }
  }
};
